import { render, staticRenderFns } from "./EdicionFormulario.vue?vue&type=template&id=f6713ba4&scoped=true&"
import script from "./EdicionFormulario.vue?vue&type=script&lang=js&"
export * from "./EdicionFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6713ba4",
  null
  
)

export default component.exports